export var formatObjectAddress = (obj) => {
	if (obj === undefined || obj === null || obj.address1 === undefined || obj.address1 === null 
		|| obj.city === undefined || obj.city === null || obj.state === undefined || obj.state === null)
		return "";

	return formatAddress(obj.address1, obj.address2, obj.city, obj.state, obj.zip);
}

export var formatAddress = (adr1, adr2, city, state, zip) => {
	if (!adr1 || adr1.length === 0 || !city || city.length === 0)
		return "";

	var adr = adr1;
	
	if (adr2 !== null && adr2.length > 0)
		adr += " " + adr2;
	
	adr += " " + city;

	if (state && state.length > 0) {
	    adr += " " + state;
    }
	
	if (zip !== null && zip.length > 0)
		adr += " " + zip;

	return adr;
}

export var formatBuildingAddress = (building, isShowZip = true, isShowState = true) => {
	return formatAddress(building.street_number + " " + building.street_name, null, building.city,
        isShowState ? building.state : null,
		isShowZip ? building.zip : null
    );
}

export var formatRentalAddress = (rental, isIncludeCity = true, isIncludeState = true, isIncludeZip = true, isInludeNeighborhood = true) => {
	if (!rental)
		return "";

	var street_number = "";
	var street_name = "";
	var city = "";
	var state = "";
	var zip = "";
	var neighborhood = "";
	var unit = rental.unit;

	if (rental.building) {
		street_number = rental.building.street_number;
		street_name = rental.building.street_name;
		city = rental.building.city;
		state = rental.building.state;
		zip = rental.building.zip;
		neighborhood = rental.building.neighborhood;
	} else {
		street_number = rental.street_number;
		street_name = rental.street_name;
		city = rental.city;
		state = rental.state;
		zip = rental.zip;
		neighborhood = rental.neighborhood;
	}

	if (!street_number || street_number.length === 0 || !street_name || street_name.length === 0 || !city || city.length === 0 
		|| !state || state.length === 0) {
		return "";
	}
	
	var adr = street_number + " " + street_name;

	if (unit && unit.length > 0)
		adr += ", #" + unit;

	if (isIncludeCity)
		adr += ", " + city;

	if (isIncludeState)
		adr += ", " + state;

	if (isIncludeZip && zip && zip.length > 0)
		adr += " " + zip;

	if (isInludeNeighborhood && neighborhood && neighborhood.length > 0)
		adr += " (" + neighborhood + ")";

	return adr;
}


// WEBPACK FOOTER //
// ./src/helpers/addressHelper.js